module.exports = __webpack_public_path__ + "static/media/29820036-KvF0wSgs.3a04ce5f.JPG";